import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UIRouter, Transition } from "@uirouter/angular";

@Injectable()
export class MailboxService {

	private _emails:BehaviorSubject<any>
  private _emailId:BehaviorSubject<any>
  private _email:BehaviorSubject<any>
  private _mailboxClassName:BehaviorSubject<any>

  constructor(private apiService : ApiService, 
              private sanitizer: DomSanitizer,
              private router: UIRouter) {

    this._emails = new BehaviorSubject([])
    this._email = new BehaviorSubject({})
    this._emailId = new BehaviorSubject('')
    this._mailboxClassName = new BehaviorSubject('')

    //this.retrieveEmails()


  }

  retrieveEmails(){
      
      		this.apiService.request('GET', '/inbound-emails/:customer', {customer: this.router.globals.params.customerId})
    		.then((response) => {

           response.forEach(eachObj => {

            eachObj.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://iframe.pouch.fyi/'+eachObj.hash)

            if(eachObj.read == null){
              eachObj.unreadClass = 'unread'
            }
            else{
              eachObj.unreadClass = ''
            }

          });

          this._emails.next(response);

        })
        .catch((error)=>{
            console.log(error)
        })

  	}

  	retrieveEmail(){

  		this.apiService.request('GET', '/inbound-email/:id', {id:this._emailId.getValue()})
    		.then((response) => {

            response.url = this.sanitizer.bypassSecurityTrustResourceUrl('https://iframe.pouch.fyi/'+response.hash)
          
          	this._email.next(response);


        })
        .catch((error)=>{
            console.log(error)
        })

  	}


    deleteEmail(){

      this.apiService.request('DELETE', '/inbound-email/'+this._emailId.getValue())
     .then((response) => {
            
            this.retrieveEmails();
      })
      .catch((error)=>{
          console.log(error)
      })



    }

    markAsSpam(){

      this.apiService.request('DELETE', '/inbound-email/'+this._emailId.getValue()+'/spam')
     .then((response) => {
            this.retrieveEmails();
      })
      .catch((error)=>{
          console.log(error)
      })

    }

    markAsRead(){

      this.apiService.request('PUT', '/inbound-email/'+this._emailId.getValue()+'/read')
     .then((response) => {
            this.retrieveEmails();
      })
      .catch((error)=>{
          console.log(error)
      })

    }

    convertEmailToPolicy(emailObj){

      this.apiService.request('POST', '/inbound-email/convert', null, emailObj)
      .then((response) => {
        this.retrieveEmail()
      })
      .catch((error)=>{
        console.log(error)
      })

    }

    set emailId(id){
      this._emailId.next(id)
      this.retrieveEmail()

    }

  	get emails(){
      //console.log('get emails')
  	  return this._emails
  	}

    get selectedEmail(){
      return this._email
    }

    set mailboxClassName(value){
      this._mailboxClassName.next(value)
    }
    get mailboxClassName(){
      return this._mailboxClassName
    }


}



// WEBPACK FOOTER //
// /Users/mattspringbett/sites/cycler/apollo-admin/src/src/app/mailbox-service/mailbox.service.ts